import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { OrderComponent } from "../../order-manager/order/order.component";
import { OrdersService } from "../../../services-otc/orders.service";
import { Router } from "@angular/router";

@Component({
    selector: 'app-order-back',
    templateUrl: './order-back.component.html',
    styleUrls: ['./order-back.component.css'],
    standalone: false
})
export class OrderBackComponent {

  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      public dialogRef: MatDialogRef<OrderComponent>,
      private ordersService: OrdersService,
      private router: Router
  ) {}

  cancelGoingbBack() {
    this.dialogRef.close();
  }
  goBack() {
    this.dialogRef.close();
  }
}

